import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LogoMark from '../components/LogoMark';

export default function AdminLogin() {
  const [form, setForm]       = useState({ username:'', password:'' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw]   = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    try { await login(form.username, form.password); nav('/admin'); }
    catch { setError('Неверный логин или пароль'); }
    setLoading(false);
  };

  const inp = (extra={}) => ({ width:'100%', padding:'12px 14px', border:'1.5px solid #E5E7EB', borderRadius:10, fontSize:'0.95rem', color:'#111', outline:'none', background:'#FAFAFA', boxSizing:'border-box', fontFamily:"'Golos Text',sans-serif", ...extra });
  const lbl = { display:'block', fontSize:'0.75rem', fontWeight:700, color:'#6B7280', marginBottom:6, letterSpacing:'0.06em', textTransform:'uppercase' };

  return (
    <div style={{ minHeight:'100vh', background:'#F5F7FA', display:'grid', placeItems:'center', padding:24, fontFamily:"'Golos Text',sans-serif" }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ display:'inline-flex', margin:'0 auto 14px', filter:'drop-shadow(0 8px 22px rgba(0,194,184,.35))' }}>
            <LogoMark size={52} />
          </div>
          <h1 style={{ fontFamily:"'Unbounded',sans-serif", fontWeight:800, fontSize:'1.4rem', color:'#06101e', margin:'0 0 4px' }}>Админ-панель</h1>
          <p style={{ color:'#9CA3AF', fontSize:'0.85rem', margin:0 }}>MasterClean Pro</p>
        </div>

        <div style={{ background:'#fff', borderRadius:18, padding:'32px 28px', boxShadow:'0 4px 32px rgba(0,0,0,.07)', border:'1px solid #F0F0F0' }}>
          <form onSubmit={submit}>
            <div style={{ marginBottom:14 }}>
              <label style={lbl}>Логин</label>
              <input value={form.username} onChange={e=>setForm(p=>({...p,username:e.target.value}))} placeholder="admin" autoComplete="username" style={inp()} onFocus={e=>e.target.style.borderColor='#00C2B8'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={lbl}>Пароль</label>
              <div style={{ position:'relative' }}>
                <input type={showPw?'text':'password'} value={form.password} onChange={e=>setForm(p=>({...p,password:e.target.value}))} placeholder="••••••••" autoComplete="current-password" style={inp({paddingRight:44})} onFocus={e=>e.target.style.borderColor='#00C2B8'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
                <button type="button" onClick={()=>setShowPw(v=>!v)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'#9CA3AF', fontSize:'1rem', padding:2 }}>{showPw?'🙈':'👁'}</button>
              </div>
            </div>
            {error && <div style={{ background:'#FEF2F2', color:'#DC2626', border:'1px solid #FCA5A5', padding:'10px 14px', borderRadius:10, fontSize:'0.85rem', marginBottom:16, display:'flex', gap:8, alignItems:'center' }}>⚠️ {error}</div>}
            <button type="submit" disabled={loading} style={{ width:'100%', padding:'13px', background:loading?'#D1D5DB':'#00C2B8', color:'#06101e', border:'none', borderRadius:10, fontFamily:"'Unbounded',sans-serif", fontWeight:700, fontSize:'0.88rem', cursor:loading?'default':'pointer', transition:'all .2s', boxShadow:loading?'none':'0 4px 16px rgba(0,194,184,.3)' }}>
              {loading ? 'Вход...' : 'Войти →'}
            </button>
          </form>
          <p style={{ textAlign:'center', marginTop:16, color:'#D1D5DB', fontSize:'0.75rem' }}>По умолчанию: admin / admin123</p>
        </div>
        <p style={{ textAlign:'center', marginTop:14 }}><a href="/" style={{ color:'#00C2B8', fontSize:'0.85rem', textDecoration:'none', fontWeight:600 }}>← На сайт</a></p>
      </div>
    </div>
  );
}
